<script setup lang="ts">
  import { MyAccountRoute } from "@/constants/routes/myAccount"
  import { Button } from "@/components/ui/button"
  import {
    Card,
    CardContent,
    CardFooter,
    CardTitle,
  } from "@/components/ui/card"
  import { Link } from "@/components/ui/link"

  import evChargingIllustration from "@/assets/illustrations/evCharging.svg"
</script>

<template>
  <Card data-testid="flex-market-subscription-card">
    <CardContent>
      <div class="flex">
        <div class="min-w-[140px]">
          <CardTitle class="mb-6">So Charged</CardTitle>
          <span>Set your EV charging schedule.</span>
        </div>
        <img
          :src="evChargingIllustration"
          alt="EV Charging at home"
          class="ml-auto w-auto max-w-[40%] flex-shrink"
        />
      </div>
    </CardContent>
    <CardFooter>
      <Button variant="tonal" as-child>
        <Link :to="MyAccountRoute.flexMarketSubscriptionApp"
          >Go to So Charged</Link
        >
      </Button>
    </CardFooter>
  </Card>
</template>
